
import { defineComponent, PropType, ref } from "vue";
import {
  calcLineAmount,
  formatAmount,
  formatQuantity,
  formatUnitPrice,
} from "@/core/helpers/number-format";
import { IVatTuDinhMucCoDinh } from "@/core/interfaces/ApiResponses";
import useVatTu from "@/core/hooks/use-vat-tu";
import VatTuDetailModal from "@/components/vat-tu/VatTuDetailModal.vue";
import Setting from "@/components/shared/setting/Setting.vue";
import type { SettingAction } from "@/components/shared/setting/Setting.vue";
import IconEye from "@/icons/IconEye.vue";
import IconTrash from "@/icons/IconTrash.vue";
import {
  VAT_TU_TABLE_COLUMN_WIDTHS,
  VatTuTable,
} from "@/components/shared/vat-tu-table";
import BaseLink from "@/components/shared/base-link/BaseLink.vue";

export default defineComponent({
  name: "dinh-muc-co-dinh-vat-tu-table",

  components: { BaseLink, Setting, VatTuDetailModal, VatTuTable },

  emits: ["remove", "refresh"],

  props: {
    curPage: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array as PropType<Array<IVatTuDinhMucCoDinh>>,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: Number,
      default: 0,
    },
    showPriceAndTotal: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const { isTextDangerColumn } = useVatTu();

    const selectedVatTuId = ref<number | undefined>(undefined);

    const normalizeCheckboxValue = (value: unknown) =>
      value === true || value === 1 || value === "1";

    const toVatTuItems = (items: IVatTuDinhMucCoDinh[] = []) =>
      items.map((item) => ({
        ...item,
        thu_hoi: normalizeCheckboxValue(item.thu_hoi),
        cong_ty_duyet: normalizeCheckboxValue(item.cong_ty_duyet),
      }));

    const vatTuItems = ref(toVatTuItems(props.items));

    return {
      columnWidths: VAT_TU_TABLE_COLUMN_WIDTHS,
      isTextDangerColumn,
      selectedVatTuId,
      vatTuItems,
      toVatTuItems,
    };
  },

  watch: {
    items(value: IVatTuDinhMucCoDinh[]) {
      this.vatTuItems = this.toVatTuItems(value);
    },
  },

  methods: {
    formatQuantity,
    formatUnitPrice,

    getSettingActions(row: IVatTuDinhMucCoDinh): SettingAction[] {
      const actions: SettingAction[] = [
        {
          icon: IconEye,
          label: "Chi tiết",
          tooltip: "Chi tiết",
          onClick: () => {
            this.selectedVatTuId = row.id;
          },
        },
      ];

      if (this.showDeleteButton) {
        actions.push({
          icon: IconTrash,
          label: "Xoá",
          tooltip: "Xoá",
          any: ["master:dinhmuccodinh:sua"],
          onClick: () => this.$emit("remove", { id_vat_tu: row.id }),
        });
      }

      return actions;
    },

    thanhTienDisplay(index: number) {
      return formatAmount(
        calcLineAmount(
          this.vatTuItems[index].don_gia,
          this.items[index].pivot.so_luong
        )
      );
    },
  },
});
